import { AuxButton } from '@interstate/components/Button';
import type { FC, PropsWithChildren, ReactNode } from 'react';
import type { ExpandableAreaKeyProp } from './types';
import { useExpandableArea } from './useExpandableArea';
import { DEFAULT_EXPANDABLE_ID, EXPANDABLE_ROOT } from '../../constants';
export type ExpandableAreaSectionProp = ExpandableAreaKeyProp &
    PropsWithChildren & {
        collapsedDisplay?: ReactNode | string;
        expandedDisplay?: ReactNode | string;
    };

/**
 * A trigger component to toggle collapse with an associated CollapsibleArea. Use collapsibleId to differentiate areas when using multiple. Expanded and collapsed text props are Show/Hide by default.
 * @param props
 */
export const ExpandableAreaSection: FC<ExpandableAreaSectionProp> = ({
    expandableId = DEFAULT_EXPANDABLE_ID,
    children,
    expandedDisplay = 'Hide Details',
    collapsedDisplay = 'Show Details',
    ...additionalButtonProps
}) => {
    const { doToggle, isExpanded } = useExpandableArea();
    const expanded = isExpanded(expandableId);
    const isRootLevel = expandableId === EXPANDABLE_ROOT;

    const handleClick: any = (e: Event) => {
        if (!isRootLevel) {
            doToggle(expandableId);
        }

        e.stopPropagation();
    };

    if (children) {
        return (
            <div
                onClick={handleClick}
                {...additionalButtonProps}
                {...(isRootLevel && {
                    id: EXPANDABLE_ROOT
                })}
            >
                {children}
            </div>
        );
    }
    return (
        <AuxButton onClick={handleClick} {...additionalButtonProps}>
            {expanded && <>{expandedDisplay}</>}
            {!expanded && <>{collapsedDisplay}</>}
        </AuxButton>
    );
};
